// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
// import Vue from "vue";
import App from './App';
Vue.prototype.vue = Vue;

import router from './router';
router.beforeEach((to, from, next) => {
  const token = Vue.prototype.func.getToken();
  if (token) {
    next();
  } else {
    //没有登录，去跳转登录页
    if (to.path === '/account/login') {
      next();
    } else {
      router.replace({
        path: '/account/login'
      });
    }
  }
})
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})

import addComponents from "./components/shared/high-components";
Vue.use(addComponents);

// import VueI18n from 'vue-i18n';
// Vue.use(VueI18n) // 通过插件的形式挂载
// const i18n = new VueI18n({
//   locale: 'zh-CN', // 语言标识
//   messages: {
//     'zh-CN': require('../../../static/i18n/all_zh-CN.json'), // 中文语言包
//     'en-US': require('../../../static/i18n/all_en-US.json') // 英文语言包
//   }
// })

// import ElementUI from 'element-ui';
// Vue.use(ElementUI, {size: 'small' })
Vue.prototype.$ELEMENT = { size: 'small' }


import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
  bgOpacity: 0.5,
  zoomEl: true,
};
Vue.use(preview, options)

import Print from 'vue-print-nb'
Vue.use(Print);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


//封装的axios
import axios from "@/server/index.js";
Vue.prototype.$axios = axios.axios;
import server from '@/server/https.js';
Vue.prototype.https = server.https;
Vue.prototype.httpUpload = server.httpUpload;
Vue.prototype.httpDownload = server.httpDownload;
Vue.prototype.configs = axios.configs;

//自定义指令
import "@/utils/directive.js";
import "@/utils/filter.js";
import func from "@/utils/func.js";
Vue.prototype.func = func;


/*引入模块公共样式*/
import "../../assets/style/theme.scss";
import "../../assets/font/iconfont.css"
import "../../assets/style/style.css";
import "./assets/css/style.css";

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)


Vue.prototype.$bus = new Vue();
import store from "@/vuex/store.js";

new Vue({
  el: '#app',
  store,
  // i18n,
  router,
  data() {
    return {
      userInfo: {},
      tenantInfo: {},
      loadingBox: null,
      wxDialogVisible: false,
      qrContent: "",
    }
  },
  created(){
    this.userInfo = this.func.getUserInfo();
    this.tenantInfo = this.func.getSession("tenantInfo") || {
      code: this.userInfo.tenantCode || this.func.getSession("tenantCode") || tenantCode || "1",
    };
  },
  mounted() {
    this.setHtmlHead();
    if (this.userInfo.token) {
      this.getUserBaseInfo();
    }
    this.getTenantInfo();
  },
  methods: {
    getUserBaseInfo(callback) {
      this.userInfo.token = this.func.getUserInfo().token || this.userInfo.token;
      let params = {
        token: this.userInfo.token
      }
      this.https("get", "/authentication/Authentication/GetInfoByToken", params).then(res => {
        if (res.success) {
          this.userInfo = Object.assign(this.userInfo, res.response || {});
          this.userInfo.tenantCode = this.func.arseJwt(this.userInfo.token).tenantCode;
          this.userInfo.roles = [];
          this.userInfo.childrenRole.map(item => {
            if (item.code && item.roleName) {
              this.userInfo.roles.push(item.code);
            }
          })
          this.userInfo.isAdmin = this.userInfo.roles.indexOf("admin") >= 0 || this.userInfo.type == -1;
          this.userInfo.pcHome = this.userInfo.pcHome || "/";
          this.userInfo.msHome = this.userInfo.msHome || "/";
          this.https("get", "/bms/permission/GetNavigationBar", {
            parentId: 0,
            permissionPlatform: "pc",
            tenantCode: this.tenantInfo.code,
            // type:this.tenantInfo.type,
          }).then(data => {
            let menus = data.response ? data.response.children || [] : [];
            this.userInfo.hasAdmin = menus.findIndex(item => item.path == "/ms") >= 0;
            for (let i = 0; i < menus.length; i++) {
              if (menus[i].path != "/ms") {
                if (menus[i].children && menus[i].children.length > 0) {
                  this.userInfo.pcHome = menus[i].children[0].path;
                } else {
                  this.userInfo.pcHome = menus[i].path;
                }
                break;
              }
            }
            this.func.setSession("userInfo", this.userInfo);
            this.$bus.$emit("Update_UserInfo", 1);
            if (typeof callback == "function") {
              callback(this.userInfo);
            }
            this.getTenantInfo();
          }).catch(res => {
            if (typeof callback == "function") {
              callback(this.userInfo);
            }
          })
        } else {
          if (typeof callback == "function") {
            callback(this.userInfo);
          }
          this.func.message("error", res.msg);
        }
      }).catch(res => {
        if (typeof callback == "function") {
          callback(this.userInfo);
        }
      })
    },
    getTenantInfo() {
      let params = {
        tenantCode: this.tenantInfo.code,
      }
      let url = "/bms/tenant/GetTenantConfig";
      if (this.userInfo.token) {
        params = {
          code: this.tenantInfo.code,
        }
        url = "/bms/tenant/GetTenant_Code";
      }
      this.https("get", url, params).then(res => {
        let data = res.response || {};
        if (!this.userInfo.token) {
          data.name = data.tenantName;
          data.logoUrl = data.tenantLogoUrl;
          data.bigLogoUrl = data.tenantBigLogoUrl;
          data.type = data.type || data.tenantType;
        }
        this.tenantInfo = Object.assign(this.tenantInfo, data);
        try {
          this.tenantInfo.parameter = JSON.parse(this.tenantInfo.parameter);
        } catch (error) {
          this.tenantInfo.parameter = {};
        }
        this.setHtmlHead();
        this.func.setSession("tenantInfo", this.tenantInfo);
        this.$bus.$emit("Update_TenantInfo", 1);
      })
    },
    setHtmlHead(){
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      if(this.tenantInfo.logoUrl){
        link.href = this.tenantInfo.logoUrl;
      }
      document.getElementsByTagName('head')[0].appendChild(link);
      document.title = this.tenantInfo.name || "";
    },
    fullLoading(text, target) {
      this.loadingBox = this.$loading({
        lock: true,
        target,
        customClass: "full-loading",
        text: text || '操作中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
    },
    closeLoading() {
      this.loadingBox.close();
    },
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/pages/pc/main.js